<div class="wrapper w-full space-y-6 mt-6 leading-relaxed  pb-6 border-bottom flex flex-col" *ngIf="hotel">
    <h2 class="w-full flex justify-start items-center text-xl font-bold tracking-tight ">
        قوانین و مقررات
    </h2>


    <div class="flex flex-col md:flex-row">
        <h3 class="text-base text-black-500 font-bold w-40">ساعت ورود و خروج</h3>
        
        <div class="flex gap-4 mt-3 md:mt-0">
            <div class="flex flex-col justify-center items-center bg-metal-50 rounded-md py-4 w-[50%] md:w-52">
                <div class="flex justify-center items-center text-black-300 gap-2">
                    <div><i class="ico-TimeCircle flex justify-center items-center"></i></div>
                    <div class="text-sm">ساعت ورود</div>
                </div>
                <div class="text-black font-bold">
                    {{checkIn}}
                </div>
            </div>
    
            <div class="flex flex-col justify-center items-center bg-metal-50 rounded-md py-4 w-[50%] md:min-w-52">
                <div class="flex justify-center items-center text-black-300 gap-2">
                    <div><i class="ico-TimeCircle flex justify-center items-center"></i></div>
                    <h3 class="text-sm">ساعت خروج</h3>
                </div>
                <div class="text-black font-bold">
                    {{checkOut}}
                </div>
            </div>
        </div>

    </div>

    <div class="flex flex-col md:flex-row order-2 md:order-1">
        <h3 class="text-base text-black-500 font-bold w-40 hidden md:block">قوانین کلی</h3>
        <div class="flex flex-col ">
            <div class="mb-3">
                <div class="text-base text-right leading-7">مدارک</div>
                <div class="text-black-300 mt-2 text-sm !font-normal leading-7">
                    {{hotel.Rules.NeedMaritalDocuments == 1 ? 'مدارک محرمیت (شناسنامه، عقدنامه)' : 'کارت شناسایی (کارت ملی)'}}
                </div>
            </div>

            <div class="text-base text-right leading-7 md:hidden">قوانین کلی حین اسکان</div>

            <ul class="pr-8 md:pr-0 list-disc md:list-none">
                <li class="mb-3 text-sm md:text-base text-black-300 md:text-black-500 text-right leading-7">
                    ورود حیوانات خانگی، {{ hotel.Rules.PetsAllowed == 1 ? 'مجاز است' : 'ممنوع است' }}.</li>

                <li class="mb-3 text-sm md:text-base text-black-300 md:text-black-500 text-right leading-7">
                    برگزاری مهمانی با هماهنگی میزبان، {{ hotel.Rules.CeremonyAllowed == 1 ? 'مجاز است' : 'ممنوع است' }}.</li>

                <li class="mb-3 text-sm md:text-base text-black-300 md:text-black-500 text-right leading-7">
                    استعمال دخانیات داخل اقامتگاه، {{ hotel.Rules.Smoking == 1 ? 'مجاز است' : 'ممنوع است' }}.</li>

                <li class="mb-3 text-sm md:text-base text-black-300 md:text-black-500 text-right leading-7">
                    پخش موسیقی {{ hotel.Rules.PlayingMusic == 1 ? 'مجاز است' : 'ممنوع است' }}.</li>

                <li class="mb-3 text-sm md:text-base text-black-300 md:text-black-500 text-right leading-7">
                    ورود گروه‌های مجردی فقط آقا یا فقط خانم {{ hotel.Rules.SingleGroup == 1 ? 'مجاز است' : 'مجاز نیست' }}.</li>

                <li class="mb-3 text-sm md:text-base text-black-300 md:text-black-500 text-right leading-7">
                    پذیرش کودک زیر ۵ سال جزو نفرات حساب {{ hotel.Rules.FreeForChildren == 1 ? 'نمی‌شود' : 'می‌شود' }}.</li>

                <li *ngIf="hotel.Rules.TwentyFourHourEntry" class="mb-3 text-sm md:text-base text-black-300 md:text-black-500 text-right leading-7">
                    اقامتگاه دارای پذیرش ۲۴ ساعته است و در تمامی ساعات، پذیرای مهمانان است.
                </li>


            </ul>


            <div *ngIf="hotel.Rules.RulesDescription && hotel.Rules.RulesDescription.length">
                <div class="text-base text-right leading-7">سایر قوانین</div>
                <div class="text-black-300 mt-2 text-sm !font-normal leading-7 whitespace-pre-line">
                    {{hotel.Rules.RulesDescription}}
                </div>
            </div>

            <button mat-button color="primary" (click)="showModal()"
                class="!justify-self-start icon-arrow-button flex items-center text-blue-500 text-sm">
                <span>مشاهده بیشتر قوانین</span>
                <i class="ico-Left text-2xl"></i>
            </button>
        </div>

    </div>


    <div
        class="rounded-lg p-4 border border-solid border-black-50 flex justify-between items-center order-1 md:order-2">
        <div class="flex flex-col">
            <div class="flex items-center">
                <i class="ico-HotelsApartemant text-2xl"></i>
                <p class="text-black-400 font-medium mr-2 text-base">
                    قوانین لغو رزرو
                    (
                    <ng-container [ngSwitch]="hotel.Rules.CancellationPlan">
                        <ng-container *ngSwitchCase="cancellationPlanEnum.Easy">سهل گیرانه</ng-container>
                        <ng-container *ngSwitchCase="cancellationPlanEnum.Normal">متعادل</ng-container>
                        <ng-container *ngSwitchCase="cancellationPlanEnum.Hard">سختگیرانه</ng-container>
                    </ng-container>
                    )

                </p>
            </div>
            <p class="text-black-400 text-sm cursor-pointer mt-1" (click)="showModal()">مشاهده دقیق جزئیات لغو رزرو
                اقامتگاه</p>
        </div>
        <i class="ico-Left text-2xl cursor-pointer" (click)="showModal()"></i>

    </div>

    <!-- md:!hidden -->

</div>